import { UIText1, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DocumentMessage.css';
import { EOutcomingStatus, TOutcomingStatus } from '../../types/messages';
import { ChatFileLoader } from '../ChatFileLoader';

type TDocumentMessageProps = {
  isOutcoming: boolean;
  messageStatus: TOutcomingStatus;
  name: string;
  size?: string;
  src: string | null;
  onCancel: () => void;
  onReload: () => void;
};

export const DocumentMessage: React.FC<TDocumentMessageProps> = ({
  isOutcoming,
  messageStatus,
  name,
  size,
  src,
  onCancel,
  onReload,
}) => {
  const isMessageLoading = messageStatus === EOutcomingStatus.Pending;
  const isMessageFailed = messageStatus === EOutcomingStatus.Failed;

  return (
    <div className={styles['container']} data-name="DocumentMessage">
      <ChatFileLoader
        src={src}
        isLoading={isMessageLoading}
        isOutcoming={isOutcoming}
        withCancel={isMessageLoading}
        withSave={Boolean(src)}
        withReload={isMessageFailed}
        withFileIcon={!isMessageFailed && !isMessageLoading && !src}
        onCancel={onCancel}
        onReload={onReload}
      />
      <div className={styles['info']}>
        <span className={styles['name']} data-name="DocumentMessage_name">
          {src ? (
            <a href={src} download target="_blank" rel="noreferrer" className={styles['link']}>
              <UIText1 color={isOutcoming ? 'text-inverted-default' : 'text-main-default'}>{name} </UIText1>
            </a>
          ) : (
            <UIText1 color={isOutcoming ? 'text-inverted-default' : 'text-main-default'}>{name} </UIText1>
          )}
        </span>
        <UIText3
          color={isOutcoming ? 'text-inverted-default' : 'text-secondary-default'}
          data-name="DocumentMessage_size"
        >
          <span className={styles['size']}>Файл{size && ` • ${size}`}</span>
        </UIText3>
      </div>
    </div>
  );
};
